import { AppBar, Button, createStyles, DialogActions, DialogContent, DialogTitle, IconButton, InputLabel, makeStyles, MenuItem, Select, Step, StepButton, Stepper, TextField, Theme, Toolbar, Typography } from '@material-ui/core';
import * as React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { QueryClient, useQuery } from 'react-query';
import { _PortalState } from '../../helpers/state';
import * as microsoftTeams from "@microsoft/teams-js";
import { Close } from '@material-ui/icons';

export const PhaseValidationForm: React.FC<PhaseValidationFormProps> = (props: PhaseValidationFormProps) => {

    const { register, handleSubmit, errors, control, setValue } = useForm();

    const [step, setStep] = React.useState<number>(0);

    const { isLoading, isError, data, error, refetch } = useQuery<any>(['phasevalidation', props.phase.Id], async () => {
        return new Promise<any>(async (resolve, reject) => {
            if (props.phase) {
                microsoftTeams.initialize(() => {
                    microsoftTeams.authentication.getAuthToken({
                        successCallback: (token: string) => {
                            fetch(_PortalState.ApiEndpoint + "/phasevalidation?phaseid=" + props.phase.Id + '&groupid=' + _PortalState.teamsContext.groupId,
                                {
                                    method: 'GET',
                                    headers:
                                        { "Authorization": "bearer " + token }
                                })
                                .then(res => res.json())
                                .then((res: any[]) => {
                                    if (res.length > 0) {
                                        resolve(res[0]);
                                    }
                                    else
                                        resolve(null);
                                });
                        }
                    })
                });
            }
            else {
                resolve(null);
            }
        });
    }, { staleTime: 0 });

    // const [fields, setFields] = React.useState<>();

    const onSubmit = (data: any) => {
        console.log(data);
        if (step === (steps.length - 1)) {

            props.onSave({
                groupId: _PortalState.teamsContext.groupId,
                phaseId: props.phase.Id,
                data: data,
                created: props.phase.created ? props.phase.created : new Date().getTime() / 1000,
                modifiedby: _PortalState.teamsContext.userObjectId,
            });
        } else {
            setStep(step + 1);
        }
    };

    const steps = (props.phase.FieldsPhaseValidate as any[]).filter((obj, i, arr) => arr.findIndex(t => t.section === obj.section) === i).map((s, i) => {
        return {
            step: i,
            section: s.section
        }
    });
    // steps.push({
    //     step: 100,
    //     section: 'Interview questions'
    // });

    const formfieldstyle = { margin: '10px 0' };

    const useStyles = makeStyles((theme: Theme) =>
        createStyles({
            appBar: {
                position: 'relative',
            },
            title: {
                marginLeft: theme.spacing(2),
                flex: 1,
            },
        }),
    );
    const classes = useStyles();

    // console.log(props);

    if (isLoading) {
        return (<div></div>);
    }

    return (
        <>
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={props.onClose} aria-label="close">
                        <Close />
                    </IconButton>
                    <Typography variant="h6" className={classes.title}>
                        Validate {props.phase.name}
                    </Typography>
                    <Button type="submit" form="hook-form" autoFocus color="inherit">
                        {step === (steps.length - 1) ? 'Save' : 'Next'}
                    </Button>
                </Toolbar>
            </AppBar>
            {/* <DialogTitle id="form-dialog-title">
                    Validate {data.experiment.data.name}
                </DialogTitle> */}


            <DialogContent>
                <div style={{ display: 'flex' }}>
                    <Stepper style={{ padding: '25px 60px 0 0' }} connector={<div style={{ height: '25px' }}></div>} nonLinear orientation="vertical" activeStep={step}>
                        {steps.map(step => {
                            return (
                                <Step key={step.step}>
                                    <StepButton onClick={() => { setStep(step.step) }} completed={false}>
                                        {step.section}
                                    </StepButton>
                                </Step>
                            );
                        })}
                    </Stepper>
                    <form style={{ width: '65%', padding: '25px 0 0 10px' }} onSubmit={handleSubmit(onSubmit)} id="hook-form">
                        <Typography variant="overline" display="block" gutterBottom>
                            Press tab to go to the next field
                        </Typography>
                        {(props.phase.FieldsPhaseValidate as any[]).map(f => {
                            if (f.type === "choice") {
                                // console.log(data && (data as any).data ? (data as any).data[f.field] : f.choices[0]);
                                return <div key={f.field} style={{ margin: '10px 0 0 0', display: f.section === steps[step].section ? '' : 'none' }}>
                                    <InputLabel style={{ fontSize: 'small' }} >{f.text}</InputLabel>
                                    <Controller
                                        as={
                                            <Select>
                                                {/* <MenuItem></MenuItem> */}
                                                {f.choices.map((choice: string) => {
                                                    return <MenuItem value={choice}>{choice}</MenuItem>
                                                })}
                                            </Select>
                                        }
                                        label={f.text}
                                        name={f.field}

                                        control={control}
                                        defaultValue={data && (data as any).data && (data as any).data[f.field] ? (data as any).data[f.field] : f.choices[0]}
                                        rules={{ required: true }}
                                    />
                                </div>
                            }
                            else
                                return <div key={f.field} style={{ display: f.section === steps[step].section ? '' : 'none' }}>
                                    <TextField
                                        // required
                                        // InputLabelProps={{ shrink: true }}
                                        // rowsMax={4}
                                        style={formfieldstyle}
                                        rows={f.rows ? f.rows : undefined}
                                        variant="outlined"
                                        multiline
                                        fullWidth
                                        autoComplete="off"
                                        // placeholder={data ? '' : undefined}
                                        // key={f.field}
                                        defaultValue={data && (data as any).data ? (data as any).data[f.field] : ''}

                                        inputRef={register({})}
                                        name={f.field}
                                        label={f.text}
                                    />
                                </div>
                        })}
                    </form>
                </div>
            </DialogContent>
            {/* <DialogActions>
                    <Button onClick={props.onClose} color="primary">
                        Close
                </Button>
                    <Button type="submit" form="hook-form" color="primary">
                        {step === (steps.length - 1) ? 'Save' : 'Next'}
                    </Button>
                </DialogActions> */}


        </>
    );
}


interface PhaseValidationFormProps {
    phase: any;
    onClose: () => void;
    onSave: (data: any) => void;
}